import { isPlatformBrowser } from '@angular/common';
import { HttpInterceptorFn } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { Store } from '@ngrx/store';
import { SelectRegionalCountry } from 'projects/shop/src/app/layout/navbar/components/navbar-header/partials/nav-regional/store/regional-setting.selectors';
import { countriesService } from 'projects/shop/src/app/modules/home/services/countries.service';

function getCountry(isBrowser: boolean): string {
  if (!isBrowser) {
    return 'EG';
  }
  return navigator.language.split('-')[1]?.toUpperCase() ?? 'EG';
}

function toSnakeCase(str: string | null | undefined): string {
  if (!str || typeof str !== 'string') return '';
  return str.toLowerCase().trim().replace(/\s+/g, '_');
}

function getCountryCode(): string {
  const store = inject(Store);
  const country = store.selectSignal(SelectRegionalCountry)();
  if (!country) return 'eg';
  return toSnakeCase(country);
}

export const UserCountryInterceptor: HttpInterceptorFn = (request, next) => {
  const countriesCodes = inject(countriesService);
  const platformId = inject(PLATFORM_ID);
  const isBrowser = isPlatformBrowser(platformId);

  const clonedReq = request.clone({
    headers: request.headers.set(
      'X-User-Country',
      countriesCodes.countryCodes[getCountryCode()] ?? getCountry(isBrowser),
    ),
  });
  if (request.url.includes('suggestions') || request.url.includes('suggest-language-currency')) {
    return next(request);
  } else {
    return next(clonedReq);
  }
};